export enum ECreateImageActionType {
  CreateRow,
  SplitTextCreateRow,
}
